import { useField } from 'react-final-form';
import { Wrapper } from '../Level3Section';
import { useState } from 'react';
import styled from 'styled-components';
import { CollapseIcon } from '../../../components/Icons/CollapseIcon';
import { ExpandIcon } from 'components/Icons/ExpandIcon';
import { NotesIcon } from '../icons/notes';
import { FinalReviewCheckboxNotes } from '../components/notes/FinalReviewCheckboxNotes';
import { FinalReviewImageNotes } from '../components/notes/FinalReviewImageNotes';
import { useVehicleEditing } from 'context/isAnotherUserEditingContext';
import { FinalReviewInspectorNotes } from '../components/notes/FinalReviewInspectorNotes';
import { NotesTopIcon } from 'components/VehicleCommon/Notes/NotesTopIcon';
import { useSmartTextBreak } from 'hooks/useSmartTextBreak';

type Props = {
  field: string;
  title: string;
  type: 'checkbox' | 'image' | 'inspector_notes';
};

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0px;
`;

const IconWrapper = styled.div<{ withAutoMargin?: boolean }>`
  display: flex;
  position: relative;
  margin-left: ${props => (props.withAutoMargin ? 'auto' : 0)};
`;

const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 14.06px;
  color: #000;
  margin-left: 8px;
`;

const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

const OriginalTextLabel = styled.div`
  display: flex;
  border-radius: 8px;
  background: #ccccccb2;
  color: #000;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  width: 75px;
  letter-spacing: 0%;
  margin-right: 4px;
  height: 24px;
  align-items: center;
  justify-content: center;
`;

const fillColor = 'rgba(153, 153, 153, 1)';

export const FinalReviewNotesField = ({ field, title, type }: Props) => {
  const {
    input: { value }
  } = useField(`${field}.notes`);

  const [isExpanded, setIsExpanded] = useState(true);
  const [isNotesFieldOpen, setIsNotesFieldOpen] = useState(true);

  const toggleExpanded = () => setIsExpanded(curr => !curr);
  const toggleNotes = () => setIsNotesFieldOpen(curr => !curr);

  const showOgTextLabel = value && value.status === 'ai_used';

  const NotesField = (() => {
    if (type === 'inspector_notes') return FinalReviewInspectorNotes;
    return type === 'checkbox' ? FinalReviewCheckboxNotes : FinalReviewImageNotes;
  })();

  const { hasAnotherEditor } = useVehicleEditing();

  const parsedTitle = useSmartTextBreak(title, '/');

  return (
    <Wrapper disabled={hasAnotherEditor} withBorder background="#fff">
      <HeaderRow>
        <IconWrapper onClick={toggleExpanded}>
          {isExpanded ? <CollapseIcon fillColor={fillColor} /> : <ExpandIcon fillColor={fillColor} />}
        </IconWrapper>
        <Title>{parsedTitle}</Title>
        <HeaderControls>
          {showOgTextLabel && <OriginalTextLabel>Original Text</OriginalTextLabel>}
          <IconWrapper onClick={toggleNotes}>
            <NotesIcon isActive={isNotesFieldOpen && isExpanded} />
            {value && value.message && <NotesTopIcon iconType={value.status === 'ai_used' ? 'ai' : 'checkmark'} />}
          </IconWrapper>
          {/* <IconWrapper>
            <DragIndicator />
          </IconWrapper> */}
        </HeaderControls>
      </HeaderRow>
      {isExpanded && isNotesFieldOpen && <NotesField sectionId={field} />}
    </Wrapper>
  );
};
